import { useFormContext, Controller } from "react-hook-form";
import { TextField, TextFieldProps } from "@mui/material";
import { FC, forwardRef } from "react";

interface IProps {
    name: string;
    children: any;
}

const RHFSelect: FC<IProps & TextFieldProps> = forwardRef(({ name, children, ...other }, ref) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => {
                return (
                    <TextField
                        select
                        fullWidth
                        SelectProps={{ native: true, displayEmpty: true }}
                        error={!!error}
                        helperText={error?.message}
                        {...other}
                        {...field}
                        value={field.value || ""}
                        inputRef={ref}
                    >
                        {children}
                    </TextField>
                );
            }}
        />
    );
});

export default RHFSelect;
